// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    spotPublicGetCurrencyPairs (params?: {}): Promise<Dict>;
    spotPublicGetAccuracy (params?: {}): Promise<Dict>;
    spotPublicGetUsdToCny (params?: {}): Promise<Dict>;
    spotPublicGetAssetConfigs (params?: {}): Promise<Dict>;
    spotPublicGetWithdrawConfigs (params?: {}): Promise<Dict>;
    spotPublicGetTimestamp (params?: {}): Promise<Dict>;
    spotPublicGetTicker24hr (params?: {}): Promise<Dict>;
    spotPublicGetTicker (params?: {}): Promise<Dict>;
    spotPublicGetDepth (params?: {}): Promise<Dict>;
    spotPublicGetIncrDepth (params?: {}): Promise<Dict>;
    spotPublicGetTrades (params?: {}): Promise<Dict>;
    spotPublicGetKline (params?: {}): Promise<Dict>;
    spotPublicGetSupplementSystemPing (params?: {}): Promise<Dict>;
    spotPublicGetSupplementIncrDepth (params?: {}): Promise<Dict>;
    spotPublicGetSupplementTrades (params?: {}): Promise<Dict>;
    spotPublicGetSupplementTickerPrice (params?: {}): Promise<Dict>;
    spotPublicGetSupplementTickerBookTicker (params?: {}): Promise<Dict>;
    spotPublicPostSupplementSystemStatus (params?: {}): Promise<Dict>;
    spotPrivatePostUserInfo (params?: {}): Promise<Dict>;
    spotPrivatePostSubscribeGetKey (params?: {}): Promise<Dict>;
    spotPrivatePostSubscribeRefreshKey (params?: {}): Promise<Dict>;
    spotPrivatePostSubscribeDestroyKey (params?: {}): Promise<Dict>;
    spotPrivatePostGetDepositAddress (params?: {}): Promise<Dict>;
    spotPrivatePostDepositHistory (params?: {}): Promise<Dict>;
    spotPrivatePostCreateOrder (params?: {}): Promise<Dict>;
    spotPrivatePostBatchCreateOrder (params?: {}): Promise<Dict>;
    spotPrivatePostCancelOrder (params?: {}): Promise<Dict>;
    spotPrivatePostCancelClientOrders (params?: {}): Promise<Dict>;
    spotPrivatePostOrdersInfo (params?: {}): Promise<Dict>;
    spotPrivatePostOrdersInfoHistory (params?: {}): Promise<Dict>;
    spotPrivatePostOrderTransactionDetail (params?: {}): Promise<Dict>;
    spotPrivatePostTransactionHistory (params?: {}): Promise<Dict>;
    spotPrivatePostOrdersInfoNoDeal (params?: {}): Promise<Dict>;
    spotPrivatePostWithdraw (params?: {}): Promise<Dict>;
    spotPrivatePostWithdrawCancel (params?: {}): Promise<Dict>;
    spotPrivatePostWithdraws (params?: {}): Promise<Dict>;
    spotPrivatePostSupplementUserInfo (params?: {}): Promise<Dict>;
    spotPrivatePostSupplementWithdraw (params?: {}): Promise<Dict>;
    spotPrivatePostSupplementDepositHistory (params?: {}): Promise<Dict>;
    spotPrivatePostSupplementWithdraws (params?: {}): Promise<Dict>;
    spotPrivatePostSupplementGetDepositAddress (params?: {}): Promise<Dict>;
    spotPrivatePostSupplementAssetDetail (params?: {}): Promise<Dict>;
    spotPrivatePostSupplementCustomerTradeFee (params?: {}): Promise<Dict>;
    spotPrivatePostSupplementApiRestrictions (params?: {}): Promise<Dict>;
    spotPrivatePostSupplementSystemPing (params?: {}): Promise<Dict>;
    spotPrivatePostSupplementCreateOrderTest (params?: {}): Promise<Dict>;
    spotPrivatePostSupplementCreateOrder (params?: {}): Promise<Dict>;
    spotPrivatePostSupplementCancelOrder (params?: {}): Promise<Dict>;
    spotPrivatePostSupplementCancelOrderBySymbol (params?: {}): Promise<Dict>;
    spotPrivatePostSupplementOrdersInfo (params?: {}): Promise<Dict>;
    spotPrivatePostSupplementOrdersInfoNoDeal (params?: {}): Promise<Dict>;
    spotPrivatePostSupplementOrdersInfoHistory (params?: {}): Promise<Dict>;
    spotPrivatePostSupplementUserInfoAccount (params?: {}): Promise<Dict>;
    spotPrivatePostSupplementTransactionHistory (params?: {}): Promise<Dict>;
    contractPublicGetCfdOpenApiV1PubGetTime (params?: {}): Promise<Dict>;
    contractPublicGetCfdOpenApiV1PubInstrument (params?: {}): Promise<Dict>;
    contractPublicGetCfdOpenApiV1PubMarketData (params?: {}): Promise<Dict>;
    contractPublicGetCfdOpenApiV1PubMarketOrder (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
